import { render, staticRenderFns } from "./ModalSelectLanguage.vue?vue&type=template&id=b5e17b46&"
import script from "./ModalSelectLanguage.vue?vue&type=script&lang=js&"
export * from "./ModalSelectLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports